import type { StateType } from '../../../../states';
import { selectGRState } from '../gr/grPrimary.selector';

const emptyObj = {};

export const selectGRRoundsState = (state: StateType) => selectGRState(state).rounds ?? emptyObj;
